module.exports = __webpack_public_path__ + "img/icon.2bcfd31d.png";